import { render } from "./RecoveryView.vue?vue&type=template&id=b5e2afb6"
import script from "./RecoveryView.vue?vue&type=script&lang=js"
export * from "./RecoveryView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__